const NOTESLIST_STRUCTURE_EVENTS = {
    CUE_CREATED: 'cue.created',
    CUE_UPDATED: 'cue.updated',
    CUE_DELETED: 'cue.deleted',
    PAGE_UPDATED: 'page.updated',
    MARKER_CREATED: 'marker.created',
    MARKER_UPDATED: 'marker.updated',
    MARKER_DELETED: 'marker.deleted',
    LAYER_CREATED: 'layer.created',
    LAYER_UPDATED: 'layer.updated',
    LAYER_DELETED: 'layer.deleted',
    STRUCTURE_BATCH: 'structure.batch',
    STRUCTURE_FULL: 'structure.full'
};

export default NOTESLIST_STRUCTURE_EVENTS;


// WEBPACK FOOTER //
// ./src/lib/integration-events.js